<template>
  <div
    class="app-wrapper"
    style="height: auto; min-height: calc(100% - 44.8px);"
    :class="classObj"
  >
    <div style="display: flex; flex-direction: column;" class="main-container">
      <navbar></navbar>
      <app-main :nextBranch="nextBranch" :notificationSocket="notificationSocket"></app-main>
      <div v-if="device !== 'mobile'" class="footerClass" style="margin-top: 120px;">
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <p style="width: 400px; text-align: center; font-size: 12px;">
            Copyright © {{ year }} {{ appname }}. All rights reserved.
          </p>
        </div>
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <p style="width: 400px; text-align: center; font-size: 12px;">
            <span style="cursor: pointer;" @click="legal">Legal Terms</span>
            |
            <span style="cursor: pointer;" @click="privacy"
              >Privacy Policy</span
            >
            |
            <span style="cursor: pointer;" @click="cookie"
              >Cookie Policy</span
            >
          </p>
        </div>
      </div>
      <div v-else class="footer2Class" style="margin-top: 120px;">
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
          >
            <p style="width: 100%; text-align: center; font-size: 12px;">
              Copyright © {{ year }} {{ appname }}. All rights reserved.
            </p>
          </div>
          <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
          >
            <p style="width: 100%; text-align: center; font-size: 12px;">
              <span style="cursor: pointer;" @click="legal"
                >Legal Terms</span
              >
              |
              <span style="cursor: pointer;" @click="privacy"
                >Privacy Policy</span
              >
              |
              <span style="cursor: pointer;" @click="cookie"
                >Cookie Policy</span
              >
            </p>
          </div>
        </div>
      </div>
      <!-- <div v-if="bossLoading" style="display: flex; width: 100%; position: absolute; top: 50px; justify-content: center; align-items: center;">
        <img style="display: flex; position: relative; width: 320px;" :src="boss"/>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "@/mixin/ResizeHandler";
import SocketIO from 'socket.io-client'
import moment from 'moment'

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  props: {
    switchCompany: {
      type: Function
    },
    nextBranch: {
      type: Function
    },
    // notificationSocket: {
    //   type: Object
    // }
  },
  data() {
    return {
      notificationSocket: null,
      appname: process.env.APP_NAME,
      year: "",
    };
  },
  mounted() {
    this.year = moment().format("YYYY");
    // console.log(this.$store.state.user.branchData)
    // console.log("layout")
    // this.nextBranch()
    // console.log('layout branchSelected', this.$store.state.app.branchSelected)
    if (this.$store.state.app.branchSelected) {
      this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
        path: '/serviceNotifications-admin-socket.io',
        query: `token=${this.token}`
      })
      this.notificationSocket.on('connect', () => {
        console.log('connected')
        this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
      })
      this.notificationSocket.on('newNotification', (data) => {
        console.log('app', data)
        this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
      })
    }
  },
  destroyed() {
    this.notificationSocket.disconnect()
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    token() {
      return this.$store.state.user.token;
    },
    device() {
      return this.$store.state.app.device;
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    },
    username() {
      return this.$store.state.user.username;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    device() {
      return this.$store.state.app.device;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    }
  },
  filters: {
    roleFilter(val) {
      if (val !== "none") {
        return val[0].toUpperCase() + val.substring(1);
      } else {
        return "Manager";
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/mixin.scss";
.app-wrapper {
  color: var(--primary-color);
  @include clearfix;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.rowTop2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  height: 76px;
  background-color: var(--bg-color);
}
.rowTop3 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  // height: 108px;
  background-color: var(--bg-color);
}
</style>


// WEBPACK FOOTER //
// src/views/admin/layout/LayoutSidebarless.vue